define('native/viewmodels/TouchIdSetupDialog',['knockout', 'underscore'], function (ko, _) {

    var laContextErrors = {
            USER_CANCELLED: -2,
            SYSTEM_CANCELLED: -4
        },
        ignorableErrors = [laContextErrors.USER_CANCELLED, laContextErrors.SYSTEM_CANCELLED];

    return function TouchIdLoginDialog (
        dialog,
        nativeMessenger,
        messageChannels,
        touchIdContent
    ) {
        var self = this;

        self.dialog = dialog;

        self.title = touchIdContent.findFieldByName('title');

        self.result = ko.observable(null);

        self.content = {
            setupImage: touchIdContent.findFieldByName('touch_id_setup_image'),
            setupTitle: touchIdContent.findFieldByName('touch_id_setup_title'),
            setupMessage: touchIdContent.findFieldByName('touch_id_setup_message'),
            setupButton: touchIdContent.findFieldByName('touch_id_setup_button'),
            setupCancelButton: touchIdContent.findFieldByName('touch_id_setup_cancel_button'),
            savedImage: touchIdContent.findFieldByName('touch_id_saved_image'),
            savedTitle: touchIdContent.findFieldByName('touch_id_saved_title'),
            savedButton: touchIdContent.findFieldByName('touch_id_saved_button'),
            failedImage: touchIdContent.findFieldByName('touch_id_failed_image'),
            failedTitle: touchIdContent.findFieldByName('touch_id_failed_title'),
            failedButton: touchIdContent.findFieldByName('touch_id_failed_button'),
            errors: touchIdContent.findFieldByName('failure_reasons').withFallback([])
        };

        self.failureCode = ko.observable(null);

        self.failureReason = ko.pureComputed(function () {
            var defaultError = self.content.failedTitle(),
                error = _.find(self.content.errors(), { code: self.failureCode() + '' });

            if (error) {
                return error.message;
            } else {
                return defaultError;
            }
        });

        self.close = function () {
            dialog.close(this, self.result());
        };

        self.show = function () {
            self.result(null);
            self.failureCode(null);

            return dialog.showDialog(self);
        };

        self.tryAgain = self.result.bind(self, null);

        self.setupTouchId = function () {
            nativeMessenger.sendMessage(messageChannels.SETUP_TOUCH_ID);
        };

        self.getView = function () {
            return 'native/views/TouchIdSetupDialog.html';
        };

        self.openTouchIdSettings = function () {
            nativeMessenger.sendMessage(messageChannels.OPEN_NATIVE_URL, 'prefs:root=TOUCHID_PASSCODE');
        };

        self.touchIdResultReceived = function (isSuccess, errorCode) {

            // Error codes -2 and -4 are user/system cancelled so ignore
            if (isSuccess || (!isSuccess && !_.includes(ignorableErrors, errorCode))) {

                self.result(isSuccess);

                if (!isSuccess) {
                    self.failureCode(errorCode);
                }
            }
        };
    };
});


